import { render, staticRenderFns } from "./Ownpad.vue?vue&type=template&id=4d07bce5&scoped=true&"
import script from "./Ownpad.vue?vue&type=script&lang=js&"
export * from "./Ownpad.vue?vue&type=script&lang=js&"
import style0 from "./Ownpad.vue?vue&type=style&index=0&id=4d07bce5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d07bce5",
  null
  
)

export default component.exports